import { ROUTES } from 'constants/routes';
import Layout from 'layout/Layout';
import AuthenticationInfo from 'pages/authentication/AuthenticationInfo';
import SelfAuthError from 'pages/error/SelfAuthError';
import Initialize from 'pages/initialize';
import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

// import Internal from 'pages/error/Internal';
const NoMatch = () => (
    <>
        <Redirect to={ROUTES.ERROR} />
    </>
);
const LayoutRouter: React.SFC = () => {
    return (
        <Switch>
            <Route exact={true} path={ROUTES.SELF_SERVICES} component={Layout} />
            <Route exact={true} path={ROUTES.INITIALIZE} component={Initialize} />
            <Route path={ROUTES.ERROR} component={SelfAuthError} />
            <Route path={ROUTES.AUTHENTICATION} component={AuthenticationInfo} />
            <Route component={NoMatch} />
        </Switch>
    )
};

export default LayoutRouter;

